// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"dcf0d100","240":"285c7eeb","258":"a3bdf87f","297":"8316e1ee","354":"840846fd","404":"5344a598","409":"afc2524e","712":"c6cc10f9","723":"3d0f66ea","812":"18fdb774","862":"1d281135"}[chunkId] + ".chunk.css";
};